import {noop} from 'lodash';
import {connect} from 'react-redux';

import {TeamModel} from '../../../../../libs/shared/core/src/models/api/teamModel';
import {logger} from '../../../../../libs/shared/core/src/services/logger/logger';
import {getShouldLogWorkspaceInboxEdits} from '../../../../../libs/shared/core/src/store/featureFlags/featureFlagsSelectors';
import {createSelector, makeMapStateToProps} from '../../../../../srcCommon/helpers/reselectHelpers';
import {AppState} from '../../../../store/appState';
import {getUserTeamParticipatingInboxes} from '../../../../store/data/inboxes/inboxesSelectors';
import {
  ToggleDropdownTeamInboxHandler,
  workspacesEditorDropdownHeight,
  workspacesEditorDropdownWidth,
} from '../editor/context/types';
import {WorkspaceInboxesDropdown} from './workspaceInboxesDropdown';

/*
 * Props.
 */

interface WorkspaceInboxesDropdownContainerProps {
  team: TeamModel;
  onToggleTeamInbox: ToggleDropdownTeamInboxHandler;
  visibleInboxesIds: number[];
}

/*
 * Selectors.
 */

function getTeam(_state: AppState, props: WorkspaceInboxesDropdownContainerProps) {
  return props.team;
}

function makeGetInboxes() {
  return createSelector(
    [getTeam, getUserTeamParticipatingInboxes, getShouldLogWorkspaceInboxEdits],
    (team, inboxes, shouldLogWorkspaceInboxEdits) => {
      const filteredInboxes = inboxes.filter((i) => i.namespace === team.namespace);
      if (shouldLogWorkspaceInboxEdits) {
        logger.info('Editing workspace inboxes', {team, inboxes, filteredInboxes});
      }
      return filteredInboxes;
    },
  );
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<WorkspaceInboxesDropdownContainerProps>()(() => ({
  inboxes: makeGetInboxes(),
}));

/**
 * This component is adapted from the now-removed <WorkspaceInboxesDropdownContainer /> but for use in <WorkspacesEditor />.
 */
export const WorkspacesEditorInboxesDropdownContainer = connect(
  mapStateToProps,
  {},
  (stateProps, dispatchProps, ownProps) => {
    const toggleInbox = (inboxId: number) => {
      const inbox = stateProps.inboxes.find((i) => i.id === inboxId);
      if (inbox) {
        ownProps.onToggleTeamInbox(inbox, ownProps.team.id);
      }
    };

    return {
      ...stateProps,
      ...ownProps,
      navigateToInbox: noop,
      hideAllInboxes: noop,
      toggleInbox,
      isInboxVisible: (inboxId: number) => ownProps.visibleInboxesIds.includes(inboxId),
      isEditingWorkspace: true,
      hasAddInboxPermission: false,
      width: workspacesEditorDropdownWidth,
      height: workspacesEditorDropdownHeight,
    };
  },
)(WorkspaceInboxesDropdown);
